import React from "react";
import * as Icons from "lucide-react";
import { PILLARS } from "@/data/site";

export const Differentiators = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14 lg:py-20" data-testid="differentiators">
    <div className="max-w-2xl">
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>Perché scegliere SENIORCAR</h2>
      <p className="mt-3 text-lg text-slate-600">Quattro motivi che fanno la differenza nella mobilità di tutti i giorni.</p>
    </div>
    <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {PILLARS.map((p) => {
        const Icon = Icons[p.icon] || Icons.Circle;
        return (
          <div key={p.title} className="rounded-2xl bg-white border border-slate-200 p-6 hover:-translate-y-1 hover:shadow-md transition-all" data-testid={`pillar-${p.title.toLowerCase()}`}>
            <div className="w-12 h-12 rounded-xl flex items-center justify-center text-white mb-4" style={{ backgroundColor: "var(--sc-emerald)" }}><Icon size={24} /></div>
            <h3 className="text-xl font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>{p.title}</h3>
            <p className="mt-2 text-slate-600 leading-relaxed">{p.text}</p>
          </div>
        );
      })}
    </div>
  </section>
);
